import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePaginatedPatientPrescriptions = (patientId, page = 1, search = "", rows = 5) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["paginatedPatientPrescriptions", patientId, tenantVal, page, search, rows],
    queryFn: async () => {
      if (!patientId) return null;
      
      const axiosInstance = createAxiosInstance();
      
      try {
        const response = await axiosInstance.get(
          `${tenantVal}/patientprescription/getbypatientid/${patientId}/page`,
          {
            params: {
              page,
              rows,
              search: search.length >= 3 ? search : undefined
            }
          }
        );
        
        return response.data;
      } catch (error) {
        console.warn("Paginated API endpoint not available, using fallback:", error.response?.status);

        const fallbackResponse = await axiosInstance.get(
          `${tenantVal}/patientprescription/getbypatientid/${patientId}`
        );

        let allData = fallbackResponse.data || [];

        if (search && search.length >= 3) {
          allData = allData.filter(item => {
            const medicationList = item.medicines?.map(medicine => medicine.tradeName).join(", ") || "";
            return medicationList.toLowerCase().includes(search.toLowerCase());
          });
        }
        
        const startIndex = (page - 1) * rows;
        const endIndex = startIndex + rows;
        const paginatedData = allData.slice(startIndex, endIndex);
        
        return {
          data: paginatedData,
          totalRecords: allData.length,
          currentPage: page
        };
      }
    },
    enabled: !!patientId,
  });
};